// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../routes/routes";
import phrasebookLoad from "../../i18n";

// Redux
import { accountActions } from 'actions';

// Components
import { SubmitButton, CancelButton } from "../../components/SkyFramework/Buttons";
import { Form } from "../../components/SkyFramework/Forms";

// Constants
const phrasebook = phrasebookLoad()

class Register extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: undefined,
      email: undefined,
      firstname: undefined,
      lastname: undefined,
      company_name: undefined,
      submitted: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {

  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var registration = {
      username: this.state.username,
      email: this.state.email,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      company_name: this.state.company_name
    }
    this.props.dispatch(accountActions.register(registration));
  }

  FormProfile = () => {
    const inputs = [
      { label: phrasebook.profile.email, type: "text", placeholder: this.state.email, id: "email", name: "email", value: this.state.email, required: true },
      { label: phrasebook.profile.firstname, type: "text", placeholder: this.state.firstname, id: "firstname", name: "firstname", value: this.state.firstname, required: true },
      { label: phrasebook.profile.lastname, type: "text", placeholder: this.state.lastname, id: "lastname", name: "lastname", value: this.state.lastname, required: true },
      { label: phrasebook.profile.company_name, type: "text", placeholder: this.state.company_name, id: "company_name", name: "company_name", value: this.state.company_name },
    ]
    const buttons = [<CancelButton title={phrasebook.common.cancel} link={gisRoutes.account.login} />, <SubmitButton title={phrasebook.common.register} />]
    return (
      <Form
        handleSubmit={this.handleSubmit}
        onChange={this.handleChange}
        title={phrasebook.profile.user_information}
        inputs={inputs}
        buttons={buttons}
      />)
  }

  render() {
    return (this.FormProfile());
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}


const register = connect(mapStateToProps)(Register);
export default (register);
